import { Alert as MuiAlert } from '@mui/material';
import type { AlertProps as MuiAlertProps } from '@mui/material';
import { ReactNode } from 'react';
import { OverridableStyles } from '~/utils/types.ts';

export type Severity = 'success' | 'info' | 'warning' | 'error';
type ExtendMuiAlertProps = MuiAlertProps & OverridableStyles;
export interface AlertProps extends ExtendMuiAlertProps {
  severity: Severity;
  children: ReactNode;
  dataTestId?: string;
}
const Alert: React.FC<AlertProps> = ({
  children,
  severity,
  styleOverrides,
  dataTestId,
  ...passthroughProps
}) => {
  return (
    <MuiAlert
      {...passthroughProps}
      severity={severity}
      sx={styleOverrides}
      data-test-id={dataTestId}
    >
      {children}
    </MuiAlert>
  );
};

export default Alert;
